import "./filter-categ-component-styles.scss";

const FilterCategComponent = ({
	filterCategs,
	activeFilter,
	setActiveFilter,
}) => {
	return (
		<div className="filter-categories">
			{filterCategs.map((categ, index) => (
				<a
					key={index}
					className={`filter-btn ${
						activeFilter === categ ? " active" : ""
					}`}
					onClick={() => setActiveFilter(categ)}
				>
					{categ}
				</a>
			))}
		</div>
	);
};

export default FilterCategComponent;
